(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["react-middle-ellipsis"] = factory(require("react"));
	else
		root["react-middle-ellipsis"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__798__) {
return 